export default {
    requiredFields: "Field is required.",
    passwordMatch: "Passwords must match.",
    passwordUpdatedMessage: "Success! Your password has been updated.",
    restrictedAge: 18
}